import React, { PureComponent } from 'react'
import PropTypes                from 'prop-types'
import './index.less'

class NoResult extends PureComponent {

  static defaultProps = {
    prompt1: '对不起',
    prompt2: '没有匹配到合适的院校哦',
    resetBtnText: '重新搜索',
    onResetSearch: () => {
    },
  }

  static propTypes = {
    prompt1: PropTypes.string,
    prompt2: PropTypes.string,
    resetBtnText: PropTypes.string,
    onResetSearch: PropTypes.func,
  }

  render() {
    const { prompt1, prompt2, resetBtnText, onResetSearch } = this.props
    return (
      <div className="no-result">
        <div>
          <p>{prompt1}</p>
          <p>{prompt2}</p>
        </div>
        <button className="primary" onClick={onResetSearch}>{resetBtnText}</button>
      </div>
    )
  }
}

export default NoResult


// WEBPACK FOOTER //
// ./src/components/NoResult/index.js